export const save = (search) => {
  localStorage.setItem('evs.latestSearch', search);
};

export const remove = () => {
  localStorage.removeItem('evs.latestSearch');
};

export const get = () => localStorage.getItem('evs.latestSearch');
